import Vue from 'vue'
import Router from 'vue-router'
import appDownLoad from '@/pages/appDownLoad/partnerDownLoad'
import Index from '@/pages/index/index';
Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      children:[
        {
          name:'appDownLoad',
          path: '/',
          redirect: '/appDownLoad',
          component: appDownLoad,
          meta: {
              title: '想象力教育科技',
              keywords: 'APP下载，美国想象力英语APP下载，imaginelearning，imaginelearning APP下载，想象力英语APP下载 ',
              description: '美国想象力英语APP下载页，提供ipad版、android版、iMac版、window版各版本下载。美国想象力英语，随时随地，立享美国课堂，合伙人招募4006688991。'
            }
        },
        {
          name:'appDownLoad',
          path: '/appDownLoad',
          component: appDownLoad,
          meta: {
              title: '想象力教育科技',
              keywords: 'APP下载，美国想象力英语APP下载，imaginelearning，imaginelearning APP下载，想象力英语APP下载 ',
              description: '美国想象力英语APP下载页，提供ipad版、android版、iMac版、window版各版本下载。美国想象力英语，随时随地，立享美国课堂，合伙人招募4006688991。'
            }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js